import { mockCustomerType } from './MockCustomerProducts';

export const mockCustomer = async () => {
	await new Promise((resolve) => setTimeout(resolve, 250));
	switch (mockCustomerType) {
		case -1:
			return mockUnknownCustomer_;
		default:
			return mockCustomer_;
	}
};

const mockCustomer_ = {
	customer_id: '0000000001',
	businessbrand: '339996a3-4df2-4230-bfe9-3051a98500cb',
	account_list: [
		{
			account_id: '0000000001',
			alt_account_id: '00000001',
			source_system: 'CodanTIA',
		},
	],
	tags: '#private #customer #insurance #CodanTIA',
	name: 'mock-customer@clients',
	person: {
		person_id: '0000000001',
		cpr_nr: '0101900000',
		firstname: 'Ida',
		lastname: 'Testkunde',
		roles: [],
	},
	contact: {
		contact_details: [
			{
				detail: '001000000000001AAA',
				type: 'Account_18_character_ID__c',
			},
			{
				detail: 'PRIVATE',
				type: 'Customer_Type__c',
			},
			{
				detail: 'Ida',
				type: 'FirstName',
			},
			{
				detail: '00000000',
				type: 'Mobile__c',
			},
			{
				detail: 'Testkunde',
				type: 'LastName',
			},
			{
				detail: 'ida.testkunde@example.com',
				type: 'Email__c',
			},
			{
				detail: 'Ida Testkunde',
				type: 'Name',
			},
		],
	},
	consent: [],
};

const mockUnknownCustomer_ = {
	account_list: [],
	tags: '#unknown #NotABGroupCustomer',
	name: 'mock-unknown-customer@clients',
	consent: [],
};
